import { AbilityBuilder, AbilityClass, PureAbility } from "@casl/ability";

export type Subjects =
  | "preorder"
  | "user"
  | "products"
  | "manager"
  | "new-order-notifications"
  | "my-orders-page"
  | "pending-orders-page"
  | "stock-management-page"
  | "detailed-ordering-page"
  | "staff-page";

export type Actions =
  | "approve"
  | "navigate"
  | "delete"
  | "create"
  | "update"
  | "invite"
  | "promote"
  | "enable";

export type AppAbility = PureAbility<[Actions, Subjects]>;

export const defineManagerAbilities = (): AppAbility => {
  const { can, cannot, build } = new AbilityBuilder<AppAbility>(
    PureAbility as AbilityClass<AppAbility>,
  );

  can("delete", "preorder");
  can("approve", "preorder");
  can("invite", "user");
  can("promote", "user");
  can("create", "preorder");
  can("enable", "new-order-notifications");
  can("navigate", [
    "staff-page",
    "my-orders-page",
    "pending-orders-page",
    "stock-management-page",
    "detailed-ordering-page",
  ]);

  cannot("update", "manager");
  cannot("delete", "manager");

  return build({});
};

export const defineStaffMemberAbilities = (): AppAbility => {
  const { cannot, can, build } = new AbilityBuilder<AppAbility>(
    PureAbility as AbilityClass<AppAbility>,
  );

  cannot("delete", "preorder");
  cannot("approve", "preorder");
  cannot("create", "user");
  cannot("update", "manager");
  cannot("delete", "manager");
  cannot("invite", "user");
  cannot("promote", "user");
  cannot("enable", "new-order-notifications");
  cannot("navigate", "staff-page");

  can("navigate", [
    "my-orders-page",
    "pending-orders-page",
    "stock-management-page",
    "detailed-ordering-page",
  ]);
  can("create", "preorder");

  return build({});
};

export const defineUnassignedUserAbilities = (): AppAbility => {
  const { cannot, build } = new AbilityBuilder<AppAbility>(
    PureAbility as AbilityClass<AppAbility>,
  );

  cannot("create", "user");
  cannot("create", "preorder");
  cannot("navigate", [
    "staff-page",
    "my-orders-page",
    "pending-orders-page",
    "stock-management-page",
    "detailed-ordering-page",
  ]);

  cannot("update", "manager");
  cannot("delete", "manager");
  cannot("invite", "user");
  cannot("promote", "user");
  cannot("enable", "new-order-notifications");

  return build({});
};
